import { BrowserModule } from '@angular/platform-browser';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  DoBootstrap,
  ElementRef
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialGlobalModule } from './shared/modules/material-global.module';

// Vendors
import { CookieService } from 'ngx-cookie-service';
import { FormStore } from '@ptl/angular-redux-form';

// PTL Library Imports
import { StateModule } from '@ptl/state';
import { PtlBrandModule } from '@ptl/brand';
import { PtlxhrConfigModule } from './shared/modules/ptlxhr-config.module';
import { PtlGlobalComponentsModule } from '@ptl/global-components';

// Root App Components Here (Why?)
import { AppComponent } from './app.component';
import { MedicalInformationModule } from './angular-elements/medical-information/medical-information.module';
import { DemographicsModule } from './angular-elements/demographics/demographics.module';
import { PlanSelectionModule } from './angular-elements/plan-selection/plan-selection.module';
import { ProducerModule } from './angular-elements/producer/producer.module';
import { UserProfileModule } from './angular-elements/user-profile/user-profile.module';
import { MarketingModule } from './angular-elements/marketing/marketing.module';

import { PreLoginAppStatusModule } from './angular-elements/application-status/pre-login-app-status/pre-login-app-status.module';
import { FormWrappersModule } from './angular-elements/form-wrappers/form-wrappers.module';
import { OnExchangeModule } from './angular-elements/on-exchange-enrollment/on-exchange-module';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

@NgModule({
  declarations: [
    AppComponent
  ],
  providers: [
    FormStore,
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false }
    }
  ],
  imports: [
    // Angular Modules
    BrowserModule,
    BrowserAnimationsModule,
    // Library - subapp config
    PtlxhrConfigModule,
    PtlGlobalComponentsModule,
    // Library
    StateModule,
    PtlBrandModule,
    // Angular Materials
    MaterialGlobalModule,
    // Angular Extensions
    ReactiveFormsModule,
    FormsModule,
    // SXEAEM Functionality
    FormWrappersModule,
    MedicalInformationModule,
    DemographicsModule,
    PlanSelectionModule,
    ProducerModule,
    MarketingModule,
    UserProfileModule,
    PreLoginAppStatusModule,
    OnExchangeModule
  ],
  // bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule implements DoBootstrap {
  constructor() { }

  // https://github.com/angular/angular/issues/31135
  // Necessary to not get errors associated w/ attachShadow to Angular Element
  ngDoBootstrap() { }
}
